////////////
// FIRST-IMPORT:START
// its important that these imports are done before any
// other imports becouse they need to be parced in the
// the correct order so that anything depending on this
// can be assured the exist. For css this is especially
// important so that style overrides are written in the
// correct order.
////////////
import 'regenerator-runtime/runtime';
import './styles.scss';

////////////
// FIRST-IMPORT:END
////////////
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import global from './modules/global/async';
import createStore from './store';
import { createBrowserHistory } from 'history';
import './i18n';
import { ConnectedRouter } from 'connected-react-router';
import AsyncContext from './components/AsyncContext';
import { Provider as FeatureProvider } from './components/FeatureFlip';
import { NamespacesConsumer } from 'react-i18next';
import Debug from 'debug';
import { SITES } from 'lib/constants';

// import registerServiceWorker from './registerServiceWorker'

// expose debug globaly so that it can be enabled in the console.
// ex: Debug.enable('mnd:*');
window.Debug = Debug;

const debug = Debug('mnd:reader:setup');

const envPath = process.env.REACT_APP_BASENAME;
const pathname = window.location.pathname;
const site = SITES[pathname.split('/')[1]] || SITES['com'];
const basename = `${site.path}/${envPath}/`;

const history = createBrowserHistory({
  basename: basename,
});

const { Component } = global;
const el = document.getElementById('root');
let store;

ReactDOM.render(
  <NamespacesConsumer ns="translation">
    {(t, { i18n }) => {
      store =
        store ||
        (() => {
          debug(
            `created store with translations function ${t('common_success')}`,
          );
          return createStore({
            history,
            i18n,
            initialState: {
              global: {
                site: site,
              },
            },
          });
        })();
      return (
        <Provider store={store}>
          <FeatureProvider history={history}>
            <AsyncContext.Provider
              value={{
                injectReducers: store.injectReducers,
                injectSagas: store.injectSagas,
              }}
            >
              <ConnectedRouter history={history}>
                <Component />
              </ConnectedRouter>
            </AsyncContext.Provider>
          </FeatureProvider>
        </Provider>
      );
    }}
  </NamespacesConsumer>,
  el,
);

// // registerServiceWorker()
// // if (module.hot && process.env.NODE_ENV !== 'production') {
// //   module.hot.accept('./modules/global', () => {
// //     ReactDOM.render(<Provider store={store}><global /></Provider>, el)
// //   })
// // }
